import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(1)};
  padding-top: ${({ theme }) => theme.spacing(2.5)};
  padding-bottom: ${({ theme }) => theme.spacing(12)};
`

export const Form = styled.form`
  width: 100%;
  max-width: 31.25rem;
  & > h1 {
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }

  .contact-us-input {
    width: 100%;
    margin-bottom: ${({ theme }) => theme.spacing(2.5)};
  }

  .contact-us-textarea {
    min-height: 9.5rem;
  }

  .contact-us-button {
    height: 2.5rem;
    width: 5.625rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${({ theme }) => theme.spacing(0.5)};
    outline: none;
    background-color: #38d39f;
    color: #fff;
    cursor: pointer;
    border: none;
  }
`

export const ButtonWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2.5)};
`
